import { render, staticRenderFns } from "./AsiListTable.vue?vue&type=template&id=cc80adb6&scoped=true&"
import script from "./AsiListTable.vue?vue&type=script&lang=ts&"
export * from "./AsiListTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc80adb6",
  null
  
)

export default component.exports